import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PercentageIcon } from '../../../../../../../styles';
import { StyledIconButton } from './shared-styles';

interface DisplayPercentageToggleProps {
  onClick: () => void;
}

export const DisplayPercentageToggle = (
  props: DisplayPercentageToggleProps
) => {
  const { onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      title={t('common:commonValues.tooltips.togglePercentage')}
      placement="top"
    >
      <StyledIconButton
        onClick={handleClick}
        size="small"
        aria-label="Toggle Percentage"
      >
        <PercentageIcon />
      </StyledIconButton>
    </Tooltip>
  );
};
